import React from 'react';
import styled from 'styled-components';
import notFound from '../../images/404.jpg';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;

  img {
    width: 320px;
    margin-bottom: 8px;
  }

  h1 {
    margin: 0 0 16px 0;
    color: ${props => props.theme.textColor};
    font-size: 36px;
    font-weight: 400;
    text-align: center;
  }

  h3 {
    margin: 0;
    font-size: 24px;
    font-weight: 400;
    color: ${props => props.theme.textColor};
    text-align: center;

    a {
      color: ${props => props.theme.accent1Color};
      text-decoration: none;
    }
  }
`;

const InvalidDrive = () => (
  <Wrapper>
    <img src={notFound} alt="404" />
    <h1>Don&#39;t get lost</h1>
    <h3>
      Visit <a href="http://www.myanatomy.in/">MyAnatomy</a> to get information about latest campus drive.
    </h3>
  </Wrapper>
);

export default InvalidDrive;



// WEBPACK FOOTER //
// ./src/views/NotFound/NotFound.js